import { checkIsInternalCompany } from 'app/auth/authUtils';
import _ from 'lodash';
import { createSelector } from 'reselect';

import { impoundCategoryOptions } from 'constants/options';
import searchItems from 'utils/searchItems';

import { getIsFromInternalCompany } from 'store/auth/selectors';
import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

export const selectImpoundTypes = createSelector(getSystem, ({ impoundTypes }) => impoundTypes);

const selectImpoundTypesValues = createSelector(
  [selectImpoundTypes, getIsFromInternalCompany],
  (impoundTypes, isInternalCompany) =>
    _.sortBy(impoundTypes, [({ name }) => _.toLower(name)]).map(impoundType => ({
      ...impoundType,
      isGlobal: !isInternalCompany && checkIsInternalCompany(impoundType),
      categoryName: impoundCategoryOptions.find(o => impoundType.category === o.value)?.name,
    })),
);

const selectExistingImpoundTypesValues = createSelector(selectImpoundTypesValues, impoundTypes =>
  impoundTypes.filter(impoundType => !impoundType.isDeleted),
);

export const selectImpoundTypesOptions = createSelector(selectImpoundTypesValues, impoundTypes =>
  impoundTypes.map(({ impoundTypeId, name, category, categoryName }) => ({
    name,
    value: impoundTypeId,
    category,
    categoryName,
  })),
);

export const selectExistingImpoundTypesOptions = createSelector(
  selectExistingImpoundTypesValues,
  impoundTypes =>
    impoundTypes.map(({ impoundTypeId, name, category, categoryName }) => ({
      name,
      value: impoundTypeId,
      category,
      categoryName,
    })),
);

export const selectImpoundTypesOptionsByCategory = createSelector(
  selectImpoundTypesOptions,
  impoundTypes => _.groupBy(impoundTypes, 'category'),
);

export const selectExistingImpoundTypesOptionsByCategory = createSelector(
  selectExistingImpoundTypesOptions,
  impoundTypes => _.groupBy(impoundTypes, 'category'),
);

export const selectFilteredImpoundTypes = createSelector(
  getDebouncedSearchValue,
  selectImpoundTypesValues,
  searchItems(impoundType => [impoundType.name]),
);
